import { selector } from 'recoil';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { teamId } from '../atoms/teamId';
import { methodNameEnum } from './makePHPRequest';

export const getTeamNameById = selector({
  key: 'getTeamNameById',
  get: ({ get }) => {
    try {
      const data = {
        call: methodNameEnum.GET_BUSINESS_TEAMS,
      };
      const teams = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_TEAMS,
          payloadJsonString: JSON.stringify(data),
        })
      );
      const tId = get(teamId);
      const team = teams?.response?.data?.result.find(
        (t) => t.teamid === Number(tId)
      );
      if (team) {
        const fullTeamName = team.teamname;
        return fullTeamName;
      }
    } catch (error) {
      throw error;
    }
  },
});
